module.exports = "https://bin.bnbstatic.com/_next/static/images/Michele Zilocchi-f39d0908289d4fb0613cd8c5172c2e30.jpg";